<template>
  <div class="bg-white min-h-screen flex flex-col">
    <TSkipLink />
    <RenderTemplateHeader />

    <main id="main" class="flex-1">
      <UPage>
        <UPageHeader
          class="sticky top-0 z-30 bg-white mb-6 px-4 p-4 lg:px-8 lg:py-8 shadow-xs"
        >
          <slot name="sticky"></slot>
        </UPageHeader>
        <div class="mt-8 pb-24">
          <TContainer>
            <slot name="top"></slot>
            <MenuBreadcrumb />
          </TContainer>
          <slot />
        </div>
      </UPage>
    </main>

    <RenderTemplateFooter class="z-0" />
  </div>
</template>

<script setup lang="ts">
import { useTemplateDataComposable } from '~~/modules/template/composables/useTemplateDataComposable'
await useTemplateDataComposable({
  template: 'sticky',
})
</script>
